import { clsx } from 'clsx';

import { Button } from '@treezor/design-system';

import { BrandingIcon } from '@/ui-kit/BrandingIcon/BrandingIcon';

import { TEmptyStateProps } from './EmptyState.types';

export function EmptyState({
  title,
  state,
  action,
  icon,
  onClick,
  size = 'm',
  className,
  buttonIcon,
  testId,
}: TEmptyStateProps) {
  return (
    <div className={clsx('flex flex-col justify-center items-center w-full text-primary p-4 text-center', className)}>
      {icon && (
        <div className="pb-4">
          <BrandingIcon size={size === 'm' ? 'l' : 'xxl'} name={icon} />
        </div>
      )}
      <div>
        {title && (
          <div className={clsx('text-secondary', size === 'm' ? 'font-semibold text-base' : 'font-bold text-2xl')}>
            {title}
          </div>
        )}
        {state && (
          <div className={clsx('text-sm text-secondary whitespace-pre-line', size === 'm' ? 'pt-2' : 'pt-4')}>
            {state}
          </div>
        )}
      </div>
      <div className={`${size === 'm' ? 'pt-2' : 'pt-4'}`}>
        {action && (
          <div className="pt-4">
            <Button
              variant="tertiary"
              size={size === 'm' ? 's' : 'm'}
              onClick={onClick}
              icon={buttonIcon === null ? undefined : buttonIcon === undefined ? 'add' : buttonIcon}
              data-testid={testId}
            >
              {action}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
